/* Deutscher Inhalt. Struktur ist identisch zu en.js, damit beide Sprachen nie auseinanderlaufen. */

const nav = {
  experience: "Erfahrung",
  education: "Ausbildung",
  projects: "Projekte",
  skills: "Kenntnisse",
  achievements: "Auszeichnungen",
  contact: "Kontakt"
};

const greeting = {
  title: "Hallo, ich bin Talal Ahmed",
  subTitle:
    "Ein Full-Stack Software Engineer, der Features von Anfang bis Ende verantwortet, vom FastAPI-Backend, das täglich Millionen Anfragen verarbeitet, bis zur React- oder Next.js-Oberfläche, die Nutzer tatsächlich anklicken. Ich schließe derzeit einen M.Sc. in Computer and Systems Engineering an der TU Ilmenau ab.",
  displayGreeting: true,
  contactButtonText: "Kontakt aufnehmen"
};

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Technische Universität Ilmenau",
      logo: require("../assets/images/tu-ilmenau.png"),
      subHeader: "M.Sc. Computer and Systems Engineering",
      duration: "November 2024 - Oktober 2026",
      desc: "Abschlussarbeit: Synchronization of Web-Based Petri Nets Multi-User Token Game (Abschluss im Oktober 2026)",
      descBullets: [
        "Entwickle die komplette Nutzeroberfläche in HTML, CSS und Vanilla JavaScript (Breakpoint-Dialog-UI, Echtzeit-Anzeige der Token-Markierungen), mit einem PHP-Socket-Handler im Hintergrund, ganz ohne Frontend-Framework."
      ]
    },
    {
      schoolName: "National University of Computer and Emerging Sciences",
      logo: require("../assets/images/nuces.png"),
      subHeader: "Bachelor of Science in Informatik",
      duration: "August 2019 - Juni 2023",
      desc: "Abschluss mit einem Grade of 1.9",
      descBullets: [
        "Ausgezeichnet mit dem Dean's List Award für die Semester Fall 2020, Fall 2021 und Spring 2023",
        "Kursinhalte: Objektorientierte Programmierung, Datenstrukturen, Algorithmen, Betriebssysteme, Datenbanken, Softwareentwicklung, Softwareentwurf & -analyse, MLOps, Cloud Computing und Web Engineering"
      ]
    }
  ]
};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Software Engineer, Werkstudent",
      company: "Markt-Pilot GmbH",
      companylogo: require("../assets/images/markt.jpeg"),
      date: "Dezember 2024 - heute",
      desc: "Backend Software Engineer, der eine produktive Extraktionsplattform mit rund 5 Millionen Anfragen pro Tag aufbaut",
      descBullets: [
        "Entwarf und implementierte mehrere FastAPI- und PostgreSQL-REST-Endpunkte innerhalb einer produktiven Extraktionsplattform mit rund 5 Millionen Anfragen pro Tag.",
        "Baute und betreute Kernservices (Request Service, Healthcheck, Sonar) mit asynchronem Python und Temporal-Workflow-Orchestrierung, die sich automatisch von Teilausfällen erholen.",
        "Baute ein LLM-gestütztes Klassifikationssystem zur Erkennung anomaler und blockierter Inhalte in der Pipeline, mit einer Unsicherheits-Schicht, die Ausgaben mit geringer Konfidenz isoliert, statt sie weiterzuleiten.",
        "Verbesserte die Extraktionsgenauigkeit um bis zu 30 % durch ZeroShot-Methodenverbesserungen und leitete die Anti-Bot-Erkennung, inklusive Einspeisung gelabelter Daten in das ML-Blockierungsmodell des Teams.",
        "Baute Observability-Tools: Error-Labeling, HTML-/Quell-Snapshots in Azure Blob Storage und Sentry-Alert-Bereinigung, damit Produktionsfehler tatsächlich nachvollziehbar wurden.",
        "Verbesserte das interne Observability-Dashboard des Teams: entwickelte neue Features und behob UI-Komponenten in TypeScript und Angular.",
        "Diagnostizierte und behob eine Reihe von Produktionsfehlern (Schema-Inkonsistenzen, Race Conditions, Probleme bei der Preisextraktion) und stellte zwei defekte CI-Pipelines wieder her, die keine Regressionen mehr erkannt hatten.",
        "Reviewte Pull Requests, koordinierte mich mit dem Operations-Team und freiberuflichen Mitwirkenden und verfolgte Aufgaben über Jira und Azure DevOps in einem agilen Team."
      ]
    },
    {
      role: "Software Engineer, Full-Stack",
      company: "Arbisoft",
      companylogo: require("../assets/images/arbisoft.png"),
      date: "Juni 2023 - November 2024",
      desc: "Full-Stack-Entwickler für zwei Produkte: LitmusTest, eine Code-Bewertungsplattform mit über 8.000 Studierenden, und MyCavago, eine kundenseitige Buchungs-App, die ich von Grund auf neu gebaut habe",
      descBullets: [
        "Manuelles Korrigieren skalierte nicht mehr für über 8.000 LitmusTest-Studierende. Baute Rubric Automation, eine regelbasierte Code-Bewertungs-Engine mit deterministischer, testbarer Bewertungslogik, und senkte den manuellen Korrekturaufwand um 75 %.",
        "LitmusTest musste auch bei gleichzeitiger Prüfungslast reaktionsschnell bleiben. Verantwortete gemeinsam das React.js/TypeScript-Frontend und die PostgreSQL-basierte API, mit Fokus auf Zuverlässigkeit bei Spitzenlast, und hielt die Plattform für über 8.000 gleichzeitige Nutzer während Live-Prüfungen stabil.",
        "MyCavagos kundenseitiges Frontend brauchte einen kompletten Neuaufbau. Schrieb die App von Grund auf mit Next.js, TypeScript und TanStack Query neu und lieferte eine moderne, responsive UI/UX für Buchungen im Reitsportbereich, verantwortet von den Anforderungen bis zum Deployment.",
        "MyCavagos Authentifizierungs- und Buchungsabläufe mussten echtem Kundenverkehr standhalten. Baute die Authentifizierungs- und Buchungsmodule, sorgte für ein durchgängig gutes Nutzererlebnis und behob kritische Produktionsfehler unter hoher gleichzeitiger Last.",
        "Arbisoft brauchte schnell eine Recruiting-Website für Hochschulabsolventen, ohne Framework-Overhead. Entwarf und baute die Fresh Grad Hiring 2024 Website komplett mit jQuery und Vanilla JavaScript, handgeschriebenem HTML/CSS, ganz ohne Framework-Abhängigkeit.",
        "Bereichsübergreifende Abstimmung war für beide Produkte nötig. Organisierte Aufgaben über Jira, reviewte Pull Requests und arbeitete direkt mit Produkt-, Design- und Kundenteams zusammen."
      ]
    }
  ]
};

const bigProjects = {
  title: "Projekte",
  subtitle: "AKTUELLE & FRÜHERE PROJEKTE, AN DENEN ICH GEARBEITET HABE",
  projects: [
    {
      image: require("../assets/images/road-intelligence.png"),
      projectName: "Road Intelligence",
      projectDesc:
        "Eine selbst entwickelte Lernplattform mit allen 1.030 offiziellen Fragen der deutschen Führerschein-Theorieprüfung Klasse B, mit adaptivem Spaced-Repetition-Lernen, einer Echtzeit-Bereitschaftsanzeige und zweisprachiger EN/DE-Unterstützung.",
      footerLink: [{name: "Website besuchen", url: "https://www.fuehrerscheintest.app"}]
    },
    {
      image: require("../assets/images/cavago.png"),
      projectName: "Cavago",
      projectDesc:
        "Schrieb das Frontend mit Next.js, TypeScript und TanStack Query von Grund auf neu, für Unternehmen aus dem Reitsportbereich.",
      footerLink: [{name: "Website besuchen", url: "https://mycavago.com/home"}]
    },
    {
      image: require("../assets/images/litmus.png"),
      projectName: "Litmustest",
      projectDesc:
        "Code-Bewertungsplattform für über 8.000 gleichzeitige Studierende; verantwortete das React/TypeScript-Frontend end-to-end.",
      footerLink: [{name: "Website besuchen", url: "https://litmustest.io/"}]
    },
    {
      image: require("../assets/images/fgh.png"),
      projectName: "Fresh Grad Hiring 2024",
      projectDesc:
        "Arbisofts Recruiting-Website für Hochschulabsolventen, von Grund auf mit jQuery und Vanilla JavaScript gebaut: semantisches HTML, handgeschriebenes CSS, keine Framework-Abhängigkeit.",
      footerLink: [{name: "Website besuchen", url: "https://freshgradhiring.arbisoft.com"}]
    },
    {
      image: require("../assets/images/qwizard.png"),
      projectName: "QWizard",
      projectDesc:
        "Ein autonomes System zur Quiz-Erstellung und -Bewertung, entwickelt mit Python, FastAPI, Docker, Next.js und gehostet auf Microsoft Azure.",
      footerLink: [{name: "Website besuchen", url: "https://qwizard-next.vercel.app/"}]
    },
    {
      image: require("../assets/images/burger.png"),
      projectName: "Burger Delivery App",
      projectDesc: "Eine Full-Stack-Webanwendung, entwickelt mit React und gehostet über Firebase.",
      footerLink: [{name: "Website besuchen", url: "https://burger-builder-a9536.web.app/"}]
    }
  ],
  display: true
};

const skillsShowcase = {
  title: "Kenntnisse",
  subTitle:
    "Ein aktiver Werkzeugkasten über den gesamten Stack hinweg: Jedes davon habe ich in echten, produktiven Systemen eingesetzt.",
  groups: [
    {
      groupName: "Frontend",
      skills: [
        {skillName: "HTML5", fontAwesomeClassname: "fab fa-html5"},
        {skillName: "CSS3", fontAwesomeClassname: "fab fa-css3-alt"},
        {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
        {skillName: "React.js", fontAwesomeClassname: "fab fa-react"},
        {skillName: "Next.js", fontAwesomeClassname: "fas fa-layer-group"},
        {skillName: "TypeScript", fontAwesomeClassname: "fas fa-code"},
        {skillName: "TanStack Query", fontAwesomeClassname: "fas fa-arrows-rotate"},
        {skillName: "jQuery", fontAwesomeClassname: "fab fa-jquery"}
      ]
    },
    {
      groupName: "Backend",
      skills: [
        {skillName: "Python", fontAwesomeClassname: "fab fa-python"},
        {skillName: "FastAPI", fontAwesomeClassname: "fas fa-bolt"},
        {skillName: "Django", fontAwesomeClassname: "fas fa-server"},
        {skillName: "PHP", fontAwesomeClassname: "fab fa-php"}
      ]
    },
    {
      groupName: "Daten & APIs",
      skills: [
        {skillName: "PostgreSQL", fontAwesomeClassname: "fas fa-database"},
        {skillName: "SQL", fontAwesomeClassname: "fas fa-table"},
        {skillName: "REST-APIs", fontAwesomeClassname: "fas fa-diagram-project"},
        {skillName: "Pydantic", fontAwesomeClassname: "fas fa-shield-halved"}
      ]
    },
    {
      groupName: "Cloud & DevOps",
      skills: [
        {skillName: "Docker", fontAwesomeClassname: "fab fa-docker"},
        {skillName: "Microsoft Azure", fontAwesomeClassname: "fab fa-microsoft"},
        {skillName: "CI/CD", fontAwesomeClassname: "fas fa-infinity"},
        {skillName: "Git", fontAwesomeClassname: "fab fa-git-alt"}
      ]
    },
    {
      groupName: "KI & Automatisierung",
      skills: [
        {skillName: "Generative KI", fontAwesomeClassname: "fas fa-brain"},
        {skillName: "NLP", fontAwesomeClassname: "fas fa-language"},
        {skillName: "Selenium", fontAwesomeClassname: "fas fa-robot"},
        {skillName: "Temporal Workflow", fontAwesomeClassname: "fas fa-clock"}
      ]
    }
  ],
  languages: {
    groupName: "Sprachen",
    items: [
      {name: "Englisch", level: "C1, Verhandlungssicher"},
      {name: "Deutsch", level: "A2, Grundkenntnisse, auf dem Weg zu B1"}
    ]
  },
  display: true
};

const achievementSection = {
  title: "Auszeichnungen und Zertifizierungen",
  subtitle: "Auszeichnungen, Zertifizierungen, Anerkennungsschreiben und andere coole Dinge, die ich gemacht habe!",
  achievementsCards: [
    {
      title: "Microsoft Azure Fundamentals (AZ-900)",
      subtitle: "Zertifizierung Microsoft Azure Fundamentals abgeschlossen",
      image: require("../assets/images/azure.png"),
      imageAlt: "Azure Fundamentals Logo",
      footerLink: [
        {name: "Zertifikat", url: "https://www.credly.com/badges/5cf97433-dd61-4277-879f-28d0e47a1470"},
      ]
    },
    {
      title: "PCEP",
      subtitle: "Certified Entry-Level Python Programmer",
      image: require("../assets/images/pcep.png"),
      imageAlt: "[PCEP-30-02] PCEP - Certified Entry-Level Python Programmer",
      footerLink: [
        {name: "Offizielles Zertifikat", url: "https://verify.openedg.org/?id=jUyu.Ar0a.6wQ7"},
        {name: "Detailliertes Ergebnis", url: "https://drive.google.com/file/d/1GJnsnGOOvbBFAACJloJuBDzrg0UyxZ71/view"}
      ]
    }
  ],
  display: true
};

const contactInfo = {
  title: "Kontakt",
  subtitle: "Ein Projekt besprechen oder einfach nur Hallo sagen? Mein Postfach ist offen für alle.",
  number: "+49-176-13722237",
  email_address: "talalahmed252@gmail.com",
  display: true
};

const content = {
  nav,
  greeting,
  educationInfo,
  workExperiences,
  bigProjects,
  skillsShowcase,
  achievementSection,
  contactInfo,
  isHireable: true
};

export default content;
